function getUrl(url, page) {
    // Check wether all settings are defined and correct and check if the link is relative
    // (absolute urls are usually external and don't need to be parsed by the bloomreach SDK)
    if (url && page && page.isPreview() && /^\/[a-zA-Z0-9_].*/.test(url)) {
        return page.getUrl(url);
    }
    return url;
}

export { getUrl };
//# sourceMappingURL=get-url.js.map
